class VariantChange extends HTMLElement {
	constructor() {
		super();

		this.popoverWrapper = this.closest('.custom-select-popover');
		this.innerWrapper = document.querySelector('.custom-popover-select');

		this.mainLabel = this.querySelector('.custom-popover-select__label') ||
			this.popoverWrapper?.querySelector('.custom-popover-select__label');

		this.rows = this.querySelectorAll('.custom-popover-row');
		this.radios = this.querySelectorAll('input[type="radio"]');

		const jsonScript = this.querySelector('script[type="application/json"]');
		try {
			this.variants = jsonScript ? JSON.parse(jsonScript.textContent) : [];
		} catch (e) {
			console.error('JSON Error:', e);
			this.variants = [];
		}

		this.init();
	}

	init() {
		this.bindEvents();

		const activeCheckedRow = this.querySelector('.custom-popover-content.active .custom-popover-row.checked');
		const checkedRadio = activeCheckedRow?.querySelector('input[type="radio"]') ||
			this.querySelector('input[type="radio"]:checked');
		if(checkedRadio) {
			checkedRadio.checked = true;
			this.updateLabel(checkedRadio);
			this.updateVisualClasses(checkedRadio);
		}
	}

	bindEvents() {
		this.radios.forEach(radio => {
			radio.addEventListener('change', (e) => {
				e.stopPropagation();
				this.handleSelection(radio, true);
			});
		});

		this.rows.forEach(row => {
			row.addEventListener('click', (e) => {
				if (e.target.tagName !== 'INPUT') {
					e.preventDefault();

					const radio = row.querySelector('input[type="radio"]');
					if (radio) {
						if (!radio.checked) {
							radio.checked = true;
							this.handleSelection(radio, true);
						} else {
							this.closePopover();
						}
					}
				}
			});
		});

		if (!window.popoverCloseListenerAdded) {
			document.addEventListener('click', (e) => {
				const openPopover = document.querySelector('.custom-select-popover.open');
				if (openPopover && !openPopover.contains(e.target)) {
					openPopover.classList.remove('open');
				}
			});
			window.popoverCloseListenerAdded = true;
		}
	}

	handleSelection(radio, shouldClose = true) {
		try {
			const adminValue = radio.value;

			this.updateLabel(radio);
			this.syncTabs(adminValue, radio);

			const matchedVariant = this.variants.find(variant => variant.options.includes(adminValue));
			if (matchedVariant) {
				const productForms = document.querySelectorAll('product-form, .product-form, form[action*="/cart/add"]');
				productForms.forEach(form => {
					const inputs = form.querySelectorAll('input[name="id"], select[name="id"]');
					inputs.forEach(input => {
						if (input.type !== 'radio') {
							input.value = matchedVariant.id;
							input.dispatchEvent(new Event('change', { bubbles: true }));
						}
					});
				});
                // Keep the native express form unavailable for sold-out sizes.
                this.closest('.js-product')?.querySelectorAll('[data-reytel-product-express]').forEach(region => {
                    const input = region.querySelector('input[name="id"]');
                    if (input) input.disabled = !matchedVariant.available;
                    region.hidden = !matchedVariant.available;
                });
				this.updateUrl(matchedVariant.id);
				this.updateContent(matchedVariant.id);
			}

		} catch (error) {
			console.error(error);
		} finally {
			if (shouldClose) {
				this.closePopover();
			}
		}
	}

	async updateContent(variantId) {
		this.requestedVariantId = variantId;
		const sectionId = this.dataset.section;
		const productUrl = this.dataset.url;

		if(!sectionId || !productUrl) return;

		try {
			const url = new URL(productUrl, window.location.origin);
			url.searchParams.set('variant', variantId);
			url.searchParams.set('section_id', sectionId);

			const response = await fetch(url);
			const text = await response.text();
			const html = new DOMParser().parseFromString(text, 'text/html');

			if (this.requestedVariantId !== variantId) return;
			this.updateElements(html);

		} catch (error) {
			console.error('Error updating price:', error);
		}
	}

	updateElements(html) {
		const selectors = [
			'.js-price-container',
			'.js-klarna-osm',
			'.sku',
		];

		selectors.forEach(selector => {
			const source = html.querySelector(selector);
			const destinations = document.querySelectorAll(selector);

			if (source && destinations.length) {
				destinations.forEach(destination => {
					destination.innerHTML = source.innerHTML;
				});
			}
		});
	}

	closePopover() {
		if (this.popoverWrapper) this.popoverWrapper.classList.remove('open');
		if (this.innerWrapper) this.innerWrapper.classList.remove('open');
	}

	updateLabel(radio) {
		if (this.mainLabel) {
			const row = radio.closest('.custom-popover-row');
			const variantText = row?.querySelector('.selector-button span')?.textContent.trim();
			const shippingText = row?.querySelector('.shipping-info')?.textContent.trim();
			const mainText = variantText || radio.value;
			this.mainLabel.textContent = shippingText
				? `${mainText} ${shippingText}`
				: mainText;
		}
	}

	syncTabs(value, currentRadio) {
		const safeValue = value.replace(/"/g, '\\"');
		const sameRadios = this.querySelectorAll(`input[value="${safeValue}"]`);
		sameRadios.forEach(r => {
			if (r !== currentRadio) r.checked = true;
			this.updateVisualClasses(r);
		});
		this.updateVisualClasses(currentRadio);
	}

	updateVisualClasses(activeRadio) {
		const activeRow = activeRadio.closest('.custom-popover-row');
		if (activeRow) {
			activeRow.parentElement.querySelectorAll('.custom-popover-row').forEach(row => {
				row.classList.remove('checked', 'selected');
			});
			activeRow.classList.add('checked', 'selected');
		}
	}

	updateUrl(variantId) {
		if (!variantId) return;
		const url = new URL(window.location);
		url.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', url);
	}
}

customElements.define('option-buttons', VariantChange);
